const BASE_PATH = "/apps";
export default class LogonApps {
  constructor(apisClient) {
    this.apis = apisClient;
  }

  async getReleasesMinVersion() {
    return this.apis.get({
      path: `${BASE_PATH}/releases/minVersion`
    });
  }

  async getReleasesExpectedVersion() {
    return this.apis.get({
      path: `${BASE_PATH}/releases/expectedVersion`
    });
  }

}